import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type InsuranceDataProps = {
  product: AbstractCase;
  title: string;
};

const InsuranceData = ({ product, title }: InsuranceDataProps) => {
  if (!product.caseInsurance.insurer) {
    return null;
  }
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"legalExpenseInsurance"} />
      {product.legalExpenseInsurance && (
        <>
          <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.insurer.name"} />
          <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.insurancePolicyNumber"} />
          <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.caseReferenceNumber"} />
          <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.policyHolderType"} />
          <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.deductible"} />

          {product.caseInsurance.policyHolderType === "familyMember" && (
            <>
              <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.policyHolder.gender"} labelPostfix={"Versicherter"} />
              <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.policyHolder.givenName"} labelPostfix={"Versicherter"} />
              <SummaryDetailsItem caseData={product} fieldPath={"caseInsurance.policyHolder.familyName"} labelPostfix={"Versicherter"} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default InsuranceData;
